import { AgentModel } from 'api-hooks/agent';
import { BankAccountModel } from 'api-hooks/bank-account';
import { ChequeGiroModel } from 'api-hooks/cheque-giro';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { PurchaseModel } from 'api-hooks/order/common/model';
import { PaymentMethodModel } from 'api-hooks/payment-method';
import { Expose, Type } from 'class-transformer';
import { ReleaseStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class PaymentableModel extends CommonModel {
  name: string;
  status: string;
  type: string;

  @Expose({ name: 'available_at' })
  @Type(() => Date)
  availableAt: Date;

  @Expose({ name: 'bank_account' })
  @Type(() => BankAccountModel)
  bankAccount: BankAccountModel;

  @Expose({ name: 'cheque_giro' })
  @Type(() => ChequeGiroModel)
  chequeGiro: ChequeGiroModel;

  @Expose({ name: 'expired_at' })
  @Type(() => Date)
  expiredAt: Date;

  @Expose({ name: 'reference_number' })
  referenceNumber: string;

  @Expose({ name: 'issued_at' })
  @Type(() => Date)
  issuedAt: Date;
}

export class RefundReleaseAgentModel {
  id: string;
  number: string;
  reason: string;
  status: ReleaseStatusEnum;

  @Type(() => AgentModel)
  agent: AgentModel;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'requested_at' })
  @Type(() => Date)
  requestedAt: Date;

  @Expose({ name: 'payment_method' })
  @Type(() => PaymentMethodModel)
  paymentMethod: PaymentMethodModel;

  @Type(() => PurchaseModel)
  purchase: PurchaseModel;

  @Type(() => PaymentableModel)
  paymentable: PaymentableModel;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class RefundReleaseAgentLiteModel {
  id: string;
  agent: string;
  number: string;
  reason: string;
  status: string;

  @Expose({ name: 'order_number' })
  orderNumber: string;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'requested_at' })
  @Type(() => Date)
  requestedAt: Date;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

//query
export type getRefundReleaseAgentsInput = {
  params: CommonParamInput & {
    status?: string;
  };
};

export type getRefundReleaseAgentInput = {
  id: string;
};

//mutation
export type RefundReleaseAgentMutationInput = object;

export type RefundReleaseAgentMutationUpdate = {
  id: string;
  body: RefundReleaseAgentMutationInput;
};
export type RefundReleaseAgentMutationDelete = {
  id: string;
};

export type RefundReleaseAgentInput = {
  releasePurchaseId: string;
};
